<kort id="gruppe-temaer" #kort>
  <kort-tittel>
    {{ 'Temaer' | translate }}
    <div class="antall">{{ '{antall} temaer' | translate: {antall: aktiveTemaer().length} }}</div>
  </kort-tittel>

  @if (visning()) {
    @if (!kort.erAktiv()) {
      <p>{{ 'Bruk temaer til å gruppere saker og si noe om innholdet. Typiske temaer er økonomi, HMS, prosjekter etc.' | translate }}</p>
      <kort-handlinger>
        <button mat-button (click)="visDetaljer()" data-testid="vis-alle-knapp">
          <mat-icon>list</mat-icon>
          {{ 'Vis alle' | translate }}
        </button>
      </kort-handlinger>

    } @else {
      <div class="innhold-kontainer">
        <table>
          <thead>
          <tr>
            <th>{{ 'Navn' | translate }}</th>
            <th class="i-bruk">{{ 'I bruk' | translate }}</th>
            <th class="arvet">{{ 'Arvet fra gruppemal' | translate }}</th>
          </tr>
          </thead>
          <tbody>
            @for (tema of aktiveTemaer(); track tema.id) {
              <tr data-testid="tema">
                <td>
                  <div class="tittel" data-testid="navn">{{ tema.navn }}</div>
                  @if (tema.beskrivelse) {
                    <html-formatert [innhold]="tema.beskrivelse" class="beskrivelse" data-testid="beskrivelse"/>
                  }
                </td>
                <td class="i-bruk">
                  <mat-icon>{{ tema.kanIkkeSlettes ? 'check_circle' : 'circle' }}</mat-icon>
                </td>
                <td class="arvet">
                  <mat-icon [attr.data-testid]="tema.harForelder ? 'arvet' : null">{{ tema.harForelder ? 'check_circle' : 'circle' }}</mat-icon>
                </td>
              </tr>
            }
          <tr>
            <td colspan="3" class="arkiverte-lenke">
              @if (viserArkiverteTemaer()) {
                <a (click)="viserArkiverteTemaer.set(false)">
                  {{ 'Skjul arkiverte temaer' | translate }}
                </a>
              } @else {
                <a (click)="viserArkiverteTemaer.set(true)" data-testid="vis-arkiverte-knapp">
                  {{ 'Vis {antall} arkiverte temaer' | translate: {antall: arkiverteTemaer().length} }}
                </a>
              }
            </td>
          </tr>
          </tbody>

          @if (viserArkiverteTemaer()) {
            <tbody class="arkiverte-temaer">
              @for (tema of arkiverteTemaer(); track tema.id) {
                <tr data-testid="tema">
                  <td>
                    <div class="tittel" data-testid="navn">{{ tema.navn }}</div>
                    @if (tema.beskrivelse) {
                      <html-formatert [innhold]="tema.beskrivelse" class="beskrivelse" data-testid="beskrivelse"/>
                    }
                  </td>
                  <td class="i-bruk">
                    <mat-icon>{{ tema.kanIkkeSlettes ? 'check_circle' : 'circle' }}</mat-icon>
                  </td>
                  <td class="arvet">
                    <mat-icon [attr.data-testid]="tema.harForelder ? 'arvet' : null">{{ tema.harForelder ? 'check_circle' : 'circle' }}</mat-icon>
                  </td>
                </tr>
              }
            </tbody>
          }
        </table>
      </div>
      <kort-handlinger>
        <button mat-button (click)="skjulDetaljer()">{{ 'Skjul' | translate }}</button>
        <button mat-button (click)="rediger()" data-testid="rediger-knapp">
          <mat-icon>edit</mat-icon>
          {{ 'Rediger' | translate }}
        </button>
      </kort-handlinger>
    }

  } @else {
    <gruppe-tema-rediger-liste
            [temaer]="temaer()"
            [gruppeId]="gruppeId()"
            (vedFerdig)="redigeringFerdig($event)"/>
  }
</kort>
